import { useContext } from 'react';
import { AdminUserContext } from './context';

/**
 * Hook to access admin user authentication context
 * @returns {Object} Admin user context with authentication state and methods
 */
export const useAdminUser = () => {
  const context = useContext(AdminUserContext);
  if (context === undefined || context === null) {
    throw new Error('useAdminUser must be used within an AdminUserProvider');
  }
  return context;
};